var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

var ForgotPasswordThree = function (_Component) {
  _inherits(ForgotPasswordThree, _Component);

  function ForgotPasswordThree() {
    _classCallCheck(this, ForgotPasswordThree);

    var _this = _possibleConstructorReturn(this, (ForgotPasswordThree.__proto__ || Object.getPrototypeOf(ForgotPasswordThree)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);

    _this.state = {
      password1: "",
      password2: ""
    };
    return _this;
  }

  _createClass(ForgotPasswordThree, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;

      event.preventDefault();

      this.props.authDrawerActions.changePassword(this.props.authDrawer.passwordResetToken, this.props.authDrawer.passwordResetEmail, this.state).then(function () {
        _this2.changeStep(authDrawerConstants.FORGOTPASSWORD4);
      });
    }
  }, {
    key: "changeStep",
    value: function changeStep(step, event) {
      if (event) {
        event.preventDefault();
      }

      this.props.authDrawerActions.changeStep(step);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.container },
        React.createElement(
          "h3",
          null,
          "Resetting password"
        ),
        React.createElement(
          "form",
          { onSubmit: this.handleSubmit },
          React.createElement(
            "div",
            { className: styles.marginTop40 },
            React.createElement("input", { onChange: this.handleChange, name: "password1", type: "password", placeholder: "New password", value: this.state.password1 })
          ),
          React.createElement(
            "div",
            { className: styles.marginTop20 },
            React.createElement("input", { onChange: this.handleChange, name: "password2", type: "password", placeholder: "Type it again", value: this.state.password2 })
          ),
          React.createElement(
            "div",
            { className: styles.nextButton },
            React.createElement(
              "button",
              { type: "submit", className: classNames(styles.blueButton1, styles.block, styles.centered) },
              "Set New Password"
            )
          )
        )
      );
    }
  }]);

  return ForgotPasswordThree;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    authDrawer: state.authDrawer
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordThree);


// WEBPACK FOOTER //
// ./src/components/Library/AuthDrawer/ForgotPasswordThree.js